<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      d="M12.8318 3.47293C12.4711 3.09147 12.1901 2.99997 12.0014 2.99997C11.8127 2.99997 11.5317 3.09147 11.171 3.47293C10.8082 3.8565 10.4355 4.4652 10.1015 5.30029C9.5201 6.75369 9.11534 8.74346 9.02197 11H14.9808C14.8875 8.74346 14.4827 6.75369 13.9014 5.30029C13.5673 4.4652 13.1946 3.8565 12.8318 3.47293Z"
    />
    <path
      d="M14.9808 13H9.02197C9.11534 15.2565 9.5201 17.2463 10.1015 18.6997C10.4355 19.5348 10.8082 20.1435 11.171 20.527C11.5317 20.9085 11.8127 21 12.0014 21C12.1901 21 12.4711 20.9085 12.8318 20.527C13.1946 20.1435 13.5673 19.5348 13.9014 18.6997C14.4827 17.2463 14.8875 15.2565 14.9808 13Z"
    />
    <path
      d="M7.02041 11C7.11461 8.53281 7.55482 6.28174 8.2445 4.55752C8.59276 3.68688 9.02032 2.91104 9.53134 2.30737C5.51587 3.32757 2.47002 6.77743 2.05078 11H7.02041Z"
    />
    <path
      d="M2.05078 13H7.02041C7.11461 15.4672 7.55482 17.7182 8.2445 19.4424C8.59276 20.3131 9.02032 21.0889 9.53133 21.6926C5.51586 20.6724 2.47002 17.2225 2.05078 13Z"
    />
    <path
      d="M16.9824 13H21.952C21.5328 17.2225 18.4869 20.6724 14.4715 21.6926C14.9825 21.0889 15.4101 20.3131 15.7583 19.4424C16.448 17.7182 16.8882 15.4672 16.9824 13Z"
    />
    <path
      d="M21.952 11C21.5328 6.77743 18.4869 3.32757 14.4715 2.30737C14.9825 2.91105 15.4101 3.68688 15.7583 4.55752C16.448 6.28174 16.8882 8.53281 16.9824 11H21.952Z"
    />
  </svg>
</template>
